<template lang="pug">
  .wrapgal
    h3 Galería del evento
    Carousel(:pics="images")
</template>
<script>
import Carousel from '@/components/Carousel'

export default {
  props: {
    gallery: Object
  },
  data(){
    return {
      images: []
    }
  },
  components: {
    Carousel
  },
  methods: {
    parseGallery(data){
      return new Promise((resolve, reject) => {
        const images = []
        data.images.map(img => {
          images.push({
            src: `${data.basepath}res/res_${img.file}`,
            thumbnail: `${data.basepath}thumb/thumb_${img.file}`,
            caption: img.name,
            width: img.width,
            height: img.height
          })
        })
        resolve(images)
      }).catch(err => reject(err))
    }
  },
  computed: {
    digestedGallery() {
      this.parseGallery(this.gallery).then(images => {
        this.images = images
      }).catch(err => {
        return false
      })
    },
  },
  beforeMount(){
    this.digestedGallery
  }
}
</script>
<style lang="scss" scoped>
  .wrapgal{
    padding-top: 2rem;
  }
  h3{
    text-align: center;
    padding-bottom: 1rem;
  }
</style>


